import i18n from "@/language/index";
import store from "@/store"

// 校验符合ip格式255.255.255.255，禁止输入127.0.0.1,适用网关、子网掩码、dns1、2
export const validateIp = (rule, value, callback) => {
    let ipReg = store.state.common.ipReg;
    if (!ipReg.test(value)) {
        // 输入的不是ip
        callback(new Error(i18n.t("deviceSip.formatError")));
    } else {
        if (value === "127.0.0.1") {
            callback(new Error(i18n.t("deviceSip.forbidTip")));
        } else {
            callback();
        }
    }
};
// 校验ip，ip上限：255.254.254.253，禁止输入127.0.0.1,只适用ip
export const validateIp1 = (rule, value, callback) => {
    let ipReg = store.state.common.ipReg1;
    if (!ipReg.test(value)) {
        // 输入的不是ip
        callback(new Error(i18n.t("deviceSip.formatError")));
    } else {
        if (value === "127.0.0.1") {
            callback(new Error(i18n.t("deviceSip.forbidTip")));
        } else {
            callback();
        }
    }
};
// 校验ServerIp，ip或域名格式：禁止输入127.0.0.1,只适用ip
export const validateServerIp = (rule, value, callback) => {
    let isIpReg = store.state.common.isIpReg;
    let ipReg = store.state.common.ipReg;
    let hostReg = store.state.common.hostReg;
    if (isIpReg.test(value)) {
        if (!ipReg.test(value)) {
            // 输入的不是ip
            callback(new Error(i18n.t("deviceSip.formatError")));
        } else {
            if (value === "127.0.0.1") {
                callback(new Error(i18n.t("deviceSip.forbidTip")));
            } else {
                callback();
            }
        }
    } else {
        if (!hostReg.test(value)) {
            // 输入的不是域名
            callback(new Error(i18n.t("deviceSip.formatError")));
        } else {
            callback();
        }
    }
};
// 校验dns2，非必填
export const validateDNS2 = (rule, value, callback) => {
    if (value.length > 0) {
        let ipReg = store.state.common.ipReg;
        if (!ipReg.test(value)) {
            // 输入的不是ip
            callback(new Error(i18n.t("deviceSip.formatError")));
        } else {
            if (value === "127.0.0.1") {
                callback(new Error(i18n.t("deviceSip.forbidTip")));
            } else {
                callback();
            }
        }
    } else {
        callback();
    }
};

// 矩阵添加区域的表单校验规则
export const validateTop = (rule, value, callback) => {
    let areaReg = /^[0-9]{0,2}$/;
    if (!areaReg.test(value)) {
        // 输入的不是数字
        callback(new Error(i18n.t("area.checkTopStart")));
    } else {
        if (Number(value) > 99 || Number(value) < 1) {
            callback(new Error(i18n.t("area.checkTopStart")));
        } else {
            callback();
        }
    }
};
export const validateEnd = (rule, value, callback) => {
    let areaReg = /^[0-9]{0,2}$/;
    if (!areaReg.test(value)) {
        // 输入的不是数字
        callback(new Error(i18n.t("area.checkTopEnd")));
    } else {
        if (Number(value) > 99 || Number(value) < 1) {
            callback(new Error(i18n.t("area.checkTopEnd")));
        } else {
            callback();
        }
    }
};
// 校验尾部
export const validateStart = (rule, value, callback) => {
    let areaReg = /^[0-9]{0,2}$/;
    if (!areaReg.test(value)) {
        // 输入的不是数字
        callback(new Error(i18n.t("area.checkLastStart")));
    } else {
        if (Number(value) > 99 || Number(value) < 1) {
            callback(new Error(i18n.t("area.checkLastStart")));
        } else {
            callback();
        }
    }
};
export const validateLast = (rule, value, callback) => {
    let areaReg = /^[0-9]{0,2}$/;
    if (!areaReg.test(value)) {
        // 输入的不是数字
        callback(new Error(i18n.t("area.checkLastEnd")));
    } else {
        if (Number(value) > 99 || Number(value) < 1) {
            callback(new Error(i18n.t("area.checkLastEnd")));
        } else {
            callback();
        }
    }
};